import React, { useState, useEffect } from 'react';
import { Form, ListGroup, InputGroup, FormControl, Button } from 'react-bootstrap';
import { FaPaperPlane } from 'react-icons/fa';
import supabase from '../../../../supabaseClient';
import './CommentSection.css';

const CommentSection = ({ postId }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');

  useEffect(() => {
    const fetchComments = async () => {
      let { data: comments, error } = await supabase
        .from('comments')
        .select('*')
        .eq('post_id', postId);

      if (error) {
        console.error('Error fetching comments:', error);
      } else {
        setComments(comments);
      }
    };

    fetchComments();
  }, [postId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newComment.trim()) {
      let { error } = await supabase
        .from('comments')
        .insert([{ post_id: postId, text: newComment, likes: 0 }]);

      if (error) {
        console.error('Error submitting comment:', error);
      } else {
        setNewComment('');
        let { data: comments, error } = await supabase
          .from('comments')
          .select('*')
          .eq('post_id', postId);

        if (error) {
          console.error('Error fetching comments:', error);
        } else {
          setComments(comments);
        }
      }
    }
  };

  return (
    <div className="comment-section">
      <Form onSubmit={handleSubmit} className="comment-form d-flex">
        <InputGroup className="flex-grow-1">
          <FormControl
            as="textarea"
            rows={1}
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            placeholder="Write a comment..."
            className="comment-input"
          />
          <Button variant="link" onClick={handleSubmit} className="post-icon-button">
            <FaPaperPlane className="post-icon" />
          </Button>
        </InputGroup>
      </Form>
      <ListGroup className="mt-3">
        {comments.map((comment) => (
          <ListGroup.Item key={comment.id} className="d-flex justify-content-between align-items-center">
            <div>
              <p>{comment.text}</p>
            </div>

          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
};

export default CommentSection;
